export const FAQ_Data = [{
        'id': 1,
        'question': 'How you are able to keep Meow Form Completely free?',
        'answer': `Currently MeowForm's  is costing me around $5 a month I am able to cover this cost.`
    },
    {
        'id': 2,
        'question': 'What if i do if a not receive email responses ?',
        'answer': ' Currenlty due to bugeting Meowform has a cap of 30,000 emails a month . so if this limit is cross you would not receive any of the email. but still you can check you dashboard for new responses'
    },
    {
        'id': 3,
        'question': 'How can i support Meowforms ? ',
        'answer': 'You can support it by contributing to meowform in github or by telling the whole world about Meowforms or by buying me a coffe or Ice Tea'
    },
    {
        'id': 4,
        'question': 'What if you stop Mainting MeowForms or Paying for the Services ',
        'answer': `Surely MeowForms will go offline but the Code is open sourced so you can deploy a the code youself if you are heavly deponded on Meowform`
    },
]